import type { SupStoredTxSettings } from "@/types";
import React, { Dispatch, SetStateAction } from "react";

import { SupFieldControl, SupNumberInput } from "@repo/core-ui";

interface Web3TxSettingsGroupSlippageProps {
  settings: SupStoredTxSettings;
  setSettings: Dispatch<SetStateAction<SupStoredTxSettings>>;
}

export default function Web3TxSettingsGroupSlippage({ settings, setSettings }: Web3TxSettingsGroupSlippageProps) {
  return (
    <div className="flex w-full justify-stretch space-x-2">
      <SupFieldControl id="swap_slippage" className="w-1/2" label="BRIDGE SLIPPAGE">
        <SupNumberInput
          prefixIcon={<span className="text-primary-200">%</span>}
          step={0.1}
          max={100}
          min={0.1}
          onChange={value => {
            if (value) {
              const valueAsNumber = Math.round(Number(value) * 100);
              setSettings({
                ...settings,
                bridgeSlippage: valueAsNumber,
              });
            }
          }}
          defaultValue="0.5"
          value={`${settings.bridgeSlippage / 100}`}
        />
      </SupFieldControl>
      <SupFieldControl className="w-1/2" id="dex_slippage" label="DEX SLIPPAGE">
        <SupNumberInput
          prefixIcon={<span className="text-primary-200">%</span>}
          step={0.1}
          max={100}
          min={0.1}
          onChange={value => {
            if (value) {
              const valueAsNumber = Math.round(Number(value) * 100);
              setSettings({
                ...settings,
                dexSlippage: valueAsNumber,
              });
            }
          }}
          defaultValue="0.1"
          value={`${settings.dexSlippage / 100}`}
        />
      </SupFieldControl>
    </div>
  );
}
